<template>
  <div class="bg-blue-500 h-full flex items-center overflow-auto pattern">
    <div class="container mx-auto h-full lg:flex items-center w-4/5 md:w-3/5 lg:w-full">
      <div class="lg:w-1/2 border-b-2 lg:border-b-0 lg:border-r-2 border-blue-400">
        <div class="text-gray-300 text-lg lg:text-3xl font-thin pt-16 pb-6 lg:pb-16 leading-lose text-center lg:text-left">
          <p class="text-3xl lg:text-4xl xl:text-5xl text-blue-200 font-medium mb-4 ">
            Aim High<span class="text-4xl lg:text-6xl">&nbsp;|&nbsp;</span>Dream Big
          </p>
          <p class="mt-2 inline-block ">We are really glad to be a part of your journey.</p><br>
          <p class="mt-2 inline-block ">Your success is what it all matters most to us.</p>
        </div>
      </div>
      <div class="lg:w-1/2 flex flex-col flex-end justify-start lg:justify-center items-center mt-8 lg:mt-16">
        <form class="bg-white border mb-6 shadow p-8 rounded-lg w-full lg:w-10/12" method="POST"
              @submit.prevent="reset"  v-if="messageVariant !== 'success'">
          <div class="flex flex-col mb-8">
            <div class="text-gray-700 flex flex-col">
              <p class="font-medium text-2xl"> Don't worry </p>
              <span class="inline-block border-2 border-blue-400 w-24"></span>
              <p class="mt-6">
                We are here to help you to recover your password.
                Please enter the email address that you used and we'll send you instruction to reset your password.
              </p>
            </div>
          </div>
          <div class="bg-red-100 border border-red-400 text-red-700 px-3 py-3 rounded mb-6" v-if="message">
            <span class="font-bold">{{ message }}</span>
          </div>
          <div class="mb-6">
            <AgInput
              v-validate="'required'"
              label="Email Address"
              name="email"
              v-model="credentials.email"
              placeholder="Enter your email address"
              :has-error="errors.has('email')"
            >
              <span class="text-sm text-red-600">{{ errors.first("email") }}</span>
            </AgInput>
          </div>
          <div class="mb-8">
            <p></p>
          </div>
          <div class="flex flex-col md:flex-row gap-4 items-center justify-between">
            <button
              class="w-full md:w-auto bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm md:text-base"
              type="submit">
              Reset Password
            </button>
            <router-link
              tag="a"
              to="/"
              class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
              exact
            >
              Back to Sign In Page
            </router-link>
          </div>
        </form>
        <div class="bg-white p-4 border mb-6 shadow p-8 rounded-lg w-3/5" v-else>
          <p class="font-medium text-2xl">Successful Password Reset ! </p>
          <span class="inline-block border-2 border-blue-400 w-24"></span>
          <p class="mt-6">
            Please check your email for further instructions.
          </p>
          <router-link
            tag="a"
            to="/"
            class="mt-6 inline-block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            exact
          >
            Login
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import AgInput from "@/components/Input/Input.vue";

  export default {
    name: "PasswordReset",
    components: {
      AgInput,
    },
    props: {
      tenant: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        message: '',
        messageVariant: 'error',
        credentials: {
          email: "",
        }
      };
    },
    methods: {
      reset() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$loading(true);
            axios
              .post('/api/reset-password', this.credentials)
              .then(response => {
                this.$loading(false);
                this.messageVariant = 'success';
              })
              .catch(error => {
                this.$loading(false);
                const errors = error.response.data;
                const status = error.response.status;
                if (status === 422) {
                  let errorFields = Object.keys(errors);
                  for (let i = 0; i < errorFields.length; i++) {
                    let field = errorFields[i];

                    let errorString = errors[field][0];
                    this.$validator.errors.add({
                      field: field,
                      msg: errorString
                    });
                  }
                  return;
                }
                this.message = error.response.data.data.message;
              });
          }
        });
      },
    }
  }
</script>
<style>
  .pattern {
    background-image: url("./../../assets/bg_login.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
